import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import "./index.css";
import Checkout from "./pages/Checkout";
import ProductList from "./pages/ProductList";
import ProductDetails from "./pages/ProductDetails";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import OtpVerify from "./components/OtpVerify";
import { ToastContainer } from "react-toastify";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import UserProfile from "./pages/UserProfile";
import ScrollToTop from "./components/ScrollTop";
import OrderPage from "./pages/MyOrders";
import OrderTracking from "./pages/OrderTracking";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyResetOtp from "./pages/VerifyReserOtp";
import AboutUs from "./pages/AboutUs";
import Contact from "./pages/Contact";
import Categories from "./pages/Categories";

function App() {
  return (
    <>
      <Router>
        <div className="flex flex-col min-h-screen">
          <Navbar />
          <main className="flex-grow">
                <ScrollToTop />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/signup/otp-verify" element={<OtpVerify />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/products/category/:categorySlug" element={<ProductList />}/>
              <Route path="/product/:slug" element={<ProductDetails />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/user-profile" element={<UserProfile />} />
              <Route path="/my-orders" element={<OrderPage />} />
              <Route path="/order-tracking" element={<OrderTracking />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
               <Route path="/verify-reset-otp" element={<VerifyResetOtp />} />
               <Route path="/about-us" element={<AboutUs />} />
               <Route path="/contact-us" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>

      <ToastContainer position="bottom-right" autoClose={3000} theme="dark" />
    </>
  );
}

export default App;
